var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('os-sub-menu-page',{attrs:{"persistent-vertical":true},scopedSlots:_vm._u([{key:"menu",fn:function(){return [_c('os-app-sub-menu',{attrs:{"menu-items":_vm.items,"tab-layout":true}})]},proxy:true}])},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }